import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { rltAtaFinalWeb } from "../api-relatorio";
import CircularProgress from '@mui/material/CircularProgress';
import RelatorioAtaFinalNotaBimestreWeb from "./RelatorioAtaFinalNotaBimestreWeb";
import RelatorioCabecalhoWeb from './Cabecalho/RelatorioCabecalhoWeb';
import { useLocation, useNavigate } from 'react-router';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: 'white',
    },
    title: {
        textAlign: 'center'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }
});

export default function RelatorioAtaFinalWeb() {
    const classes = useStyles();
    const [ataFinal, setAtaFinal] = useState();
    const location = useLocation();
    const codAlunoTurma = location.state.codAlunoTurma;
    const [isLoading, setIsLoading] = useState(true);
    const history = useNavigate();

    useEffect(() => {
        if (codAlunoTurma) {
            rltAtaFinalWeb(codAlunoTurma).then((data) => {
                if (data) {
                    if (data.error) {
                        setIsLoading(false);
                    } else {
                        setAtaFinal(data);
                        setIsLoading(false);
                    }
                }

            })
        }


    }, [codAlunoTurma]);

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Button
                    onClick={() => history(-1)}
                    variant="contained"
                    color="secondary"
                    className={classes.voltarButton}
                >
                    <ArrowBackIcon style={{ marginRight: '10px' }} />
                    Voltar
                </Button>
                <Typography className={classes.title} variant="h5">
                    Ata Final
                </Typography>
                {isLoading ?
                    <div className={classes.loading}>
                        <CircularProgress color="primary" /> Carregando...
                    </div> :
                    <>
                        <RelatorioCabecalhoWeb alunoTurma={ataFinal[0].alunoTurma} />
                        <RelatorioAtaFinalNotaBimestreWeb ataFinal={ataFinal} />
                    </>

                }







            </Container>

        </div>
    );
}